module.exports = __webpack_public_path__ + "static/media/WtbBanner.2e727c55.jpg";